module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/f3737c1bbd6dba432df60101999f0b4d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/btn_collapse_column.svg
// module id = eXo2
// module chunks = 0